import { makeStyles, type SvgIconProps } from "@material-ui/core";
import SvgIcon from "@material-ui/core/SvgIcon";
import classnames from "classnames";

interface ElephantEOnlyLogoIconProps {
  fill?: string;
  size?: number;
}

const useStyles = makeStyles({
  svgSize: ({ size }: ElephantEOnlyLogoIconProps) => ({
    width: size,
    height: size,
  }),
});

const ElephantEOnlyLogoIcon = ({
  className,
  size = 48,
  fill = "white",
  ...props
}: SvgIconProps & ElephantEOnlyLogoIconProps) => {
  const classes = useStyles({ size });

  return (
    <SvgIcon
      {...props}
      htmlColor={fill}
      className={classnames(classes.svgSize, className)}
      component="svg"
      viewBox="0 0 48 48"
    >
      <circle cx="33.7834" cy="28.6047" r="0.558267" />
      <circle cx="28.6042" cy="28.6047" r="0.558267" />
      <circle cx="23.425" cy="28.6047" r="0.558267" />
      <circle cx="23.425" cy="33.7839" r="0.558267" />
      <circle cx="18.2458" cy="28.6047" r="0.558267" />
      <circle cx="18.2458" cy="18.2463" r="0.558267" />
      <circle cx="23.425" cy="18.2463" r="0.558267" />
      <circle cx="28.6042" cy="18.2463" r="0.558267" />
      <circle cx="2.55827" cy="18.2463" r="0.558267" />
      <circle cx="2.55827" cy="23.4255" r="0.558267" />
      <circle cx="2.55827" cy="28.6047" r="0.558267" />
      <circle cx="7.88737" cy="39.0309" r="0.558267" />
      <circle cx="28.6042" cy="44.2101" r="0.558267" />
      <circle cx="23.425" cy="44.2101" r="0.558267" />
      <circle cx="18.2458" cy="44.2101" r="0.558267" />
      <circle cx="33.7831" cy="7.81971" r="0.936412" />
      <circle cx="28.6043" cy="33.784" r="1.40896" />
      <circle cx="28.6043" cy="39.031" r="1.40896" />
      <circle cx="18.2459" cy="39.031" r="1.40896" />
      <circle cx="18.2459" cy="33.784" r="1.40896" />
      <circle cx="18.2459" cy="13.0672" r="1.40896" />
      <circle cx="28.6043" cy="13.0672" r="1.40896" />
      <circle cx="7.88748" cy="18.2464" r="1.40896" />
      <circle cx="7.88748" cy="28.6048" r="1.40896" />
      <circle cx="7.8871" cy="33.7836" r="0.936412" />
      <circle cx="7.8871" cy="13.0668" r="0.936412" />
      <circle cx="13.0663" cy="7.81971" r="0.936412" />
      <circle cx="13.0663" cy="39.0307" r="0.936412" />
      <circle cx="33.7831" cy="39.0307" r="0.936412" />
      <circle cx="28.6043" cy="7.8201" r="1.40896" />
      <circle cx="18.2459" cy="7.8201" r="1.40896" />
      <circle cx="23.4249" cy="7.81993" r="1.78575" />
      <circle cx="23.425" cy="2.55827" r="0.558267" />
      <circle cx="23.425" cy="13.0671" r="0.558267" />
      <circle cx="28.6042" cy="2.55827" r="0.558267" />
      <circle cx="18.2458" cy="2.55827" r="0.558267" />
      <circle cx="7.88737" cy="7.81999" r="0.558267" />
      <circle cx="23.4249" cy="23.4254" r="1.78575" />
      <circle cx="7.88732" cy="23.4254" r="1.78575" />
      <circle cx="28.6041" cy="23.4254" r="1.78575" />
      <circle cx="33.7833" cy="33.7838" r="1.78575" />
      <circle cx="13.0665" cy="23.4254" r="1.78575" />
      <circle cx="13.0665" cy="28.6046" r="1.78575" />
      <circle cx="13.0665" cy="33.7838" r="1.78575" />
      <circle cx="23.4249" cy="39.0309" r="1.78575" />
      <circle cx="13.0665" cy="18.2462" r="1.78575" />
      <circle cx="13.0665" cy="13.067" r="1.78575" />
      <circle cx="33.7833" cy="23.4254" r="1.78575" />
      <circle cx="33.7833" cy="18.2462" r="1.78575" />
      <circle cx="33.7833" cy="13.067" r="1.78575" />
      <circle cx="18.2457" cy="23.4254" r="1.78575" />
      <circle cx="39.0001" cy="23.4254" r="1.78575" />
      <circle cx="39.0001" cy="23.4254" r="1.78575" />
      <circle cx="39.0003" cy="18.2464" r="1.40896" />
      <circle cx="38.9999" cy="33.7836" r="0.936412" />
      <circle cx="38.9999" cy="13.0668" r="0.936412" />
      <circle cx="39.0002" cy="7.81999" r="0.558267" />
      <circle cx="44.2443" cy="18.2463" r="0.558267" />
      <circle cx="44.2443" cy="23.4255" r="0.558267" />
      <circle cx="44.2443" cy="28.6047" r="0.558267" />
      <circle cx="39.0002" cy="28.6047" r="0.558267" />
      <circle cx="39.0002" cy="39.0309" r="0.558267" />
    </SvgIcon>
  );
};

export default ElephantEOnlyLogoIcon;
